import { useState } from 'react';
import Checkbox from '../../widgets/Checkbox';

type AIChatFirstUseConsentProps = {
  onAccept: () => void;
};

export default function AIChatFirstUseConsent({
  onAccept,
}: AIChatFirstUseConsentProps) {
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="flex min-h-0 flex-1 flex-col justify-center overflow-y-auto px-6 py-8">
      <div className="mx-auto w-full max-w-md">
        <h4 className="text-black-900 text-lg font-semibold">
          Before you use Intellect AI
        </h4>
        <p className="text-black-700 mt-3 text-sm leading-6">
          Intellect AI answers questions using artificial intelligence. Its
          responses can be incomplete or incorrect, and they are not a
          substitute for professional, medical, or legal advice.
        </p>
        <ul className="text-black-700 mt-4 list-disc space-y-2 pl-5 text-sm leading-6">
          <li>Review important information before you act on it.</li>
          <li>
            Avoid sharing sensitive personal details you do not want processed
            by the assistant.
          </li>
        </ul>
        <Checkbox
          name="ai-chat-consent"
          checked={agreed}
          onChange={(event) => setAgreed(event.target.checked)}
          parentClass="mt-6 !px-0"
          label="I understand that Intellect AI can make mistakes, and I agree to use it with that in mind."
          labelClass="!py-0 leading-5"
        />
        <button
          type="button"
          disabled={!agreed}
          onClick={onAccept}
          className="mt-6 w-full rounded-xl bg-gradient-to-r from-violet-500 to-indigo-600 px-4 py-3 text-sm font-semibold text-white shadow-[0_4px_12px_rgba(99,102,241,0.35)] transition hover:from-violet-600 hover:to-indigo-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Agree and continue
        </button>
      </div>
    </div>
  );
}
